import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { getCreateABundleUrl } from 'pricing-pages-lib/utils/urls';
import { useHistory } from 'react-router-dom';
import { PRODUCT_PAGE_HEADER } from '../../v2/constants/tracking/TrackingSources';
import { useIsInAppAuth } from '../../v2/hooks/user/useUserInfo';
import { trackClickedLink } from '../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CalculatorAnchorLink = ({
  defaultProductApiName
}) => {
  const history = useHistory();
  const isAuthApp = useIsInAppAuth();
  const handleClick = () => {
    const queryParams = {
      products: [`${defaultProductApiName}_1`],
      packs: []
    };
    const url = getCreateABundleUrl(isAuthApp, queryParams);
    trackClickedLink({
      type: 'internal',
      url,
      trackingSource: PRODUCT_PAGE_HEADER,
      value: getI18nText('pricingPage.pages.calculateYourPrice', {
        locale: 'en-us'
      }),
      name: 'calculate-your-price'
    });
    history.push(url);
  };
  if (isAuthApp) {
    return null;
  }
  return /*#__PURE__*/_jsx(Link, {
    marginInlineStart: "200",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.calculateYourPrice"
    })
  });
};
export default CalculatorAnchorLink;